import {
	Component,
	Input,
	AfterViewInit,
	HostListener,
	Output,
	EventEmitter,
} from "@angular/core";
import * as THREE from "three";
import { ProjectData } from "src/app/entities/project-data.entity";
import { MapControls } from "three/examples/jsm/controls/OrbitControls";

import { GestorDatas3d } from "./gestor-datas3d";
import { Datas3d } from "./datas3d";
import { Varios3d } from "./varios3d";
import { CleanPerimeters } from "../../utils/clean-perimeters";
import { ParseProjectVersion } from "../../utils/parse-project-version";
import { WebGLRenderer } from "three";
import { contains } from "jquery";

declare let ga: (p1: any, p2?: any, p3?: any, p4?: any) => {};

@Component({
	selector: "app-scheme3d",
	templateUrl: "./scheme3d.component.html",
	styleUrls: ["./scheme3d.component.scss"],
})
export class Scheme3dComponent implements AfterViewInit {
	// Entrada de los datos del proyecto en curso.
	@Input("projectData") projectData: ProjectData;
	@Output() onStateRender: EventEmitter<boolean>;
	@Input("posicion") posicion: number[] = [];

	/*******************************VARIABLES GLOBALES****************************************/

	public gestor: GestorDatas3d;

	private root: THREE.Object3D;

	private scene: THREE.Scene;
	private renderer: THREE.WebGLRenderer;
	private camera: THREE.PerspectiveCamera;
	private controls: MapControls;

	private Canvas3D;
	private infoValoresCubo: ParseProjectVersion;

	private renderRequested = false;

	//############################################################################## DATOS USADOS PARA DIBUJAR LOS PERÍMETROS
	public DTNamePerTramo = ""; // Texto usado para ubicar los objetos 3D por perímetro y tramo.
	public DTPerimeterActual: Datas3d; // Actual perímtero que se está dibujando.
	public DTTramoActual: any; // Actual tramo que se está dibujando.
	public DTRootTramo: THREE.Object3D; // Actual root 3D del tramo, usado para añadir nuevos hijos (mesh).

	// Contadores para un proyecto.
	public DTCountDoor = 0;
	public DTCountWall = 0;
	public DTCountPost = 0;
	public DTCountTornaPuntas = 0;
	public DTCountPlaqueBase = 0;
	public DTCountEspino = 0;
	private lastHeight;

	public DTMetersLUXAnudada = 0; // Usada para continuar un bastidor de tramoa a tramo cuando es una LUX ANUDADA.

	public DTHasColor = false; // Si es false -> Galvanizado, en caso contrario tiene un color.
	public DTCacheMaterials = {
		// Contiene todos los materiales usados en el perímetro en curso.
		COL_PlacaBase: undefined, // Usado para clonar material con el color actual de la placa base.
		COL_Poste: undefined,
		COL_Bayoneta: undefined,
		COL_Bastidor: undefined,
		COL_Abrazadera: undefined,
	};

	public RAD90 = 1.5707963267948966;
	public RAD180 = 3.141592653589793;
	public RAD270 = 4.71238898038469;
	public RAD360 = 6.283185307179586;
	//#######################################################################################################################

	// Se lanza después de la creación de la vista.
	constructor() {
		this.onStateRender = new EventEmitter();
	}

	ngAfterViewInit() {
		this.scene = new THREE.Scene();
		this.scene.background = new THREE.Color(0x000000);
		//this.scene.fog = new THREE.FogExp2(0xaaaaaa, 0.01);

		this.Canvas3D = document.getElementById("Canvas3D");

		// console.log('Rivisa_Player3d: new THREE scene');

		this.Canvas3D.innerWidth = this.Canvas3D.parentElement.clientWidth;
		this.Canvas3D.innerHeight = this.Canvas3D.parentElement.clientHeight;
		this.renderer = new THREE.WebGLRenderer({
			canvas: this.Canvas3D,
			antialias: true,
		});
		this.renderer.setPixelRatio(this.Canvas3D.devicePixelRatio);
		this.renderer.setSize(
			this.Canvas3D.innerWidth,
			this.Canvas3D.innerHeight
		);
		this.renderer.shadowMapEnabled = true;

		//var axisHelper = new THREE.AxesHelper(5); this.scene.add(axisHelper);

		// Recalculamos los valores de centrado (por si en el 2D se han añádido algún perímetro nuevo a tener en cuenta)
		let parse = new ParseProjectVersion();
		let centerValues = parse.computeCenter(this.projectData);

		const latitud = centerValues.placement3D.margeLat;
		const longitud = centerValues.placement3D.margeLng;

		// let rect = { up: -99999, bottom: 99999, left : 99999, right: -99999 };
		// for (let ip = 0; ip < this.projectData.perimetro.length; ip++) {
		// 	let p = this.projectData.perimetro[ip];
		// 	for (let ic = 0; ic < p.coordenadas.length; ic++) {
		// 		let c = p.coordenadas[ic];
		// 		if (c.lat > rect.up) rect.up = c.lat;
		// 		if (c.lat < rect.bottom) rect.bottom = c.lat;
		// 		if (c.lng > rect.right) rect.right = c.lng;
		// 		if (c.lng < rect.left) rect.left = c.lng;
		// 	}
		// 	valoresPosicionamiento.margeLat = (rect.up + rect.bottom) / 2;
		// 	valoresPosicionamiento.margeLng =(rect.left + rect.right) / 2;
		// }
		this.camera = new THREE.PerspectiveCamera(
			60,
			this.Canvas3D.innerWidth / this.Canvas3D.innerHeight,
			0.1,
			1000
		);
		this.camera.position.set(longitud, 22, 0);

		// controls
		this.controls = new MapControls(this.camera, this.renderer.domElement);
		this.controls.enableDamping = false; // an animation loop is required when either damping or auto-rotation are enabled
		this.controls.zoomSpeed = 0.8;
		this.controls.rotateSpeed = 0.5;
		this.controls.panSpeed = 0.5;

		//this.controls.maxPolarAngle = (Math PI / 2.0) - 0.2;
		//this.controls.minPolarAngle = 0.0;

		this.controls.screenSpacePanning = false;

		this.controls.minDistance = 0.1;
		this.controls.maxDistance = 30;

		this.controls.maxPolarAngle = Math.PI / 2.2;
		this.controls.minPolarAngle = 0.1;

		this.controls.target.set(longitud, 0, latitud);

		this.controls.update();

		/* / TODO DEBUG
		const __geo = new THREE.SphereGeometry(1, 8, 8);
		const __mat = new THREE.MeshBasicMaterial({ color: 0xff0000 });
		const __sph = new THREE.Mesh(__geo, __mat);
		__sph.position.set(0, 0, 0);
		this.scene.add(__sph);
		const __ge1 = new THREE.CylinderGeometry(1, 1, 10, 6);
		const __ma1 = new THREE.MeshBasicMaterial({ color: 0x00ff00 });
		const __cyl = new THREE.Mesh(__ge1, __ma1);
		__cyl.position.set(camarax, 0, -camaray);
		this.scene.add(__cyl);
		// TO DO DEBUG */

		// grid
		let planeGeometry = new THREE.PlaneBufferGeometry(1200, 1200);
		let material = new THREE.MeshBasicMaterial({
			color: 0xeeeeee,
			side: THREE.DoubleSide,
		});
		let plane = new THREE.Mesh(planeGeometry, material);
		plane.name = "plano";
		plane.rotation.x = Math.PI / 2;
		plane.receiveShadow = true;
		this.scene.add(plane);

		// lights
		//let lightD1 = new THREE.DirectionalLight(0xffffff);	lightD1.position.set(1, 1, 10);		this.scene.add(lightD1);
		//let lightD2 = new THREE.DirectionalLight(0xffffff);	lightD1.position.set(-1, -1, 10);	this.scene.add(lightD2);
		// let lightD3 = new THREE.DirectionalLight(0xdbdbdb); lightD2.position.set(- 1, - 1, - 10); this.scene.add(lightD3);
		let lightA = new THREE.AmbientLight(0xbbbbbb);
		this.scene.add(lightA);

		// LIGHTS
		let light = new THREE.DirectionalLight(0xaabbff, 0.3);
		light.position.x = 300;
		light.position.y = 250;
		light.position.z = -500;
		light.castShadow = true;
		this.scene.add(light);
		let light2 = new THREE.DirectionalLight(0xaabbff, 0.3);
		light2.position.x = -300;
		light2.position.y = 250;
		light2.position.z = 500;
		light2.rotation.y = this.RAD180;
		this.scene.add(light);

		this.gestor = new GestorDatas3d(true);

		this.render = this.render.bind(this);
		this.animate = this.animate.bind(this);

		this.controls.addEventListener("change", this.animate);
		window.addEventListener("resize", this.animate);

		this.main();
	}

	public ngOnDestroy(): void {
		// console.log('[Scheme3dComponent]: Calling ngOnDestroy');

		this.clearScene(this.scene);

		this.scene.dispose();
		this.controls.dispose();
		//this.renderer.getContext().getExtension('WEBGL_lose_context').loseContext();
		//this.renderer.forceContextLoss();
		this.renderer.dispose();

		this.renderer = null;
		this.controls = null;
		this.scene = null;

		this.gestor.releaseResources();
		this.gestor = null;

		this.root = null;
		//this.Canvas3D = null;
	}

	public clearScene(scene) {
		// dispose all geometries and materials in scene
		scene.traverse((object) => {
			// dispose geometries (if applies)
			if (object.geometry) {
				object.geometry.dispose();
			}

			// dispose materials (check if it's an array or a var!)
			if (object.material) {
				if (object.material.length) {
					let iMatCunt = 0;
					for (
						iMatCunt = 0;
						iMatCunt < object.material.length;
						++iMatCunt
					) {
						object.material[iMatCunt].dispose();
					}
				} else {
					object.material.dispose();
				}
			}
		});
	}

	// #######################################################################################
	private _maximoTiempoPermitido = 0;
	private main() {
		ga("send", "event", {
			eventCategory: "Esquema 3D",
			eventAction: "Iniciada",
		});

		this.gestor.insert(this.projectData);
		// Esperar la carga de todos los objetos 3D necesarios.
		this._maximoTiempoPermitido = 0;
		this.espera();
	}

	private espera() {
		if (this.gestor?.loadFinish || this._maximoTiempoPermitido > 10000) {
			// console.log('crear mundo.');
			this.drawPerimeters();
			this.onStateRender.emit(true);
			this.render();

			//DEBUG PURPOSES:
			// this.findHeightPost();
		} else {
			// console.log('cargando');
			setTimeout(() => {
				this.espera();
			}, 200);
			this._maximoTiempoPermitido += 200;
			this.onStateRender.emit(false);
		}
	}

	// Dibuja el perímetro por tramos y los tramos los dibuja por secciones.
	private drawPerimeters() {
		// Crear root del proyeto (debería ser el centro).
		this.root = new THREE.Object3D();
		this.root.name = "ROOT";
		this.root.position.set(0, 0, 0);
		this.scene.add(this.root);

		// Iniciar contadores.
		this.DTCountDoor = 0;
		this.DTCountPost = 0;
		this.DTCountTornaPuntas = 0;
		this.DTCountWall = 0;
		this.DTCountPlaqueBase = 0;
		this.DTCountEspino = 0;
		this.lastHeight = undefined;
		// Recorrer todo los prímetros del proyecto.
		for (
			let indexPerimeter = 0;
			indexPerimeter < this.gestor.datas.length;
			indexPerimeter++
		) {
			// console.log(this.gestor.datas.length);
			this.DTPerimeterActual = this.gestor.datas[indexPerimeter];
			// if(this.DTPerimeterActual.perimetro.producto.tipoPoste.indexOf('Cuadrado') !=-1){
			// 	this.DTPerimeterActual.mesh = this.DTPerimeterActual.mesh+'_CUADRADO';
			// 	console.log("TYPE",this.DTPerimeterActual.mesh);
			// }

			// Reiniciar la cache de materiales con el color del perímetro.
			this.DTHasColor = this.DTPerimeterActual.color != "";
			if (this.DTHasColor) {
				// Material usado para colorear.
				this.gestor.ColorNeutro = new THREE.MeshPhongMaterial({
					color: this.DTPerimeterActual.color,
					specular: 0,
					emissive: 0,
					shininess: 0,
				});

				// Poste.
				let result = this.gestor.postes.clonePosteMaterial(
					this.DTPerimeterActual.typePost,
					this.DTPerimeterActual.color
				);

				let colBastidor = this.gestor.bastidores.cloneVerjaMaterials(
					this.DTPerimeterActual.mesh,
					this.DTPerimeterActual.color
				);
				// COL_PlacaBase array de materiales.
				this.DTCacheMaterials = {
					COL_PlacaBase: this.gestor.varios.clonePlacaBaseMaterial(
						this.DTPerimeterActual.color
					),
					COL_Poste: result.poste,
					COL_Bayoneta: result.bayoneta,
					COL_Bastidor: colBastidor.bastidor,
					COL_Abrazadera: colBastidor.abrazadera,
				};
			}

			// Se reinicia por cada perímetro, usada por la LUX ANUDADA.
			this.DTMetersLUXAnudada = 0;

			// Crear el root del perímetro.
			let rootPerimeter = new THREE.Object3D();
			rootPerimeter.name = "Perimetre_" + indexPerimeter;

			// Todos los perimetros son hijos del root.
			this.root.add(rootPerimeter);

			rootPerimeter.position.x = this.DTPerimeterActual.coors[0].x;
			rootPerimeter.position.z = -this.DTPerimeterActual.coors[0].y;

			/*Le pasamos:
			indexPerimeter: "el numero de Perimetros(dibujos...etc) creados dentro del mismo plano"
			rootPerimeter:

			*/

			this.drawTramo(rootPerimeter, indexPerimeter);
		}
	}

	// Dibuja un tramo. (Creo que dibuja todos tramos y no solo un tramo)
	private drawTramo(rootPerimeter: any, indexPerimeter: number) {
		// Usado para recordar el último tramo encadenado (que se carga iteración).
		let ultimoTramo: THREE.Object3D;
		let magnitud = 0;
		// Recorremos todos los tramos del perímetro.

		// console.log(this.DTPerimeterActual.coors.length);

		for (
			let indexTramo = 0;
			indexTramo < this.DTPerimeterActual.coors.length - 1;
			indexTramo++
		) {
			// Obtener referencia al tramo.
			this.DTTramoActual = this.DTPerimeterActual.coors[indexTramo];

			// console.log("for LOOP this.DTPerimeterActual.coors >>>" + indexTramo);

			// Crear el root del tramo.
			this.DTRootTramo = new THREE.Object3D();

			// Nombre usado para ubicar los objetos 3D por perímetro y tramo.
			this.DTNamePerTramo = "_" + indexPerimeter + "_" + indexTramo + "_";
			this.DTRootTramo.name = "Tramo" + this.DTNamePerTramo;

			// Emparentar el root del tramo. Los tramos se encadenan.
			if (indexTramo == 0) {
				// Si es el primer tramo se emparenta con el root del perímetro.
				rootPerimeter.add(this.DTRootTramo);
			} else {
				// Si existen más tramos encadenar con el último.
				ultimoTramo.add(this.DTRootTramo);
			}

			this.DTRootTramo.position.set(magnitud, 0, 0);
			//Solo tiene magnitud y el nombre
			ultimoTramo = this.DTRootTramo;

			// Rotar tramo.
			let __p = this.DTPerimeterActual.coors[indexTramo + 1];
			this.DTRootTramo.lookAt(__p.x, 0, -__p.y);
			this.DTRootTramo.rotateY(this.RAD270);

			// Dibujar las secciones del tramo.
			magnitud = this.drawSections(indexTramo);
		}
	}

	// Dibuja las secciones de un tramo, un tramo debe tener como mínimo una sección (que represente todo el tramo).
	private drawSections(indexTramo: number) {
		// No colocar tornapuntas si son Verjas.
		let esCERCADO = this.DTPerimeterActual.familia == "CERCADO";

		// Posición inicial desde donde se empieza a dibujar el tramo.
		// Por cada tramo dibujado se le añade la magnitud del tramo.
		let _magnitudActual = 0;

		// Indica si estamos en el último tramo del perímetro.

		let lastTramo: boolean =
			indexTramo == this.DTPerimeterActual.coors.length - 2; //lastTramo boolean

		const _lastSection = this.DTTramoActual.sections.length - 1;

		// console.log("GESTOR", this.gestor.calculoPosteCuadrado)
		// Recorrer las subSecciones. (creo que son secciones no subsecciones)
		//  console.log("GRADOS DEL TRAMO ACTUAL", this.DTTramoActual.grados)

		//  for(let i = 0; i<this.gestor.calculoPosteCuadrado.length;i++){
		// 	const geometry = new THREE.SphereGeometry(32,8,8); // (radius, widthSegments, heightSegments)
		// 	const material = new THREE.MeshBasicMaterial( {color: 0xffff00} );
		// 	const sphere = new THREE.Mesh(geometry, material);
		// 	sphere.position.set(this.gestor.calculoPosteCuadrado[i].x,this.gestor.calculoPosteCuadrado[i].y,2);

		// 	this.scene.add(sphere);
		//  }

		for (
			let indiceSeccion = 0;
			indiceSeccion < this.DTTramoActual.sections.length;
			indiceSeccion++
		) {
			// console.log('Section index: ' + indiceSeccion);

			let _sectionActual = this.DTTramoActual.sections[indiceSeccion];
			// console.log("posicion tramo X-Y", _sectionActual)

			let _gradostornapuntasOK =
				this.DTTramoActual.grados >= 40 &&
				this.DTTramoActual.grados <= 140;
			// Fijamos la variablea  true para poner tornapuntas siempre en las divisiones entre tramos
			_gradostornapuntasOK = true;

			// Altura para los tornapuntas usados por los cercado.
			let alturaTornaPuntas =
				(this.DTPerimeterActual.heightPost / 100) * 75 +
				_sectionActual.height;

			// Altura de los postes en esta sección.
			let _alturaPoste =
				-5 + this.DTPerimeterActual.heightPost + _sectionActual.height;

			// ###################################################################################### PUERTAS

			if (_sectionActual.door !== "") {
				//Se introduce una puerta cuando el ÍNDICE del sector del tramo reconoce una puerta
				this.gestor.puertas.cloneDoor(
					_sectionActual.door,
					this,
					_magnitudActual + _sectionActual.margenError
				);
				if (indiceSeccion === 0) {
					// console.log('INICIO CON PUERTA ' + _sectionActual.door);
					// Creamos el poste para cerrar el perímetro anterior.
					if (this.DTPerimeterActual.closed || indexTramo > 0) {
						let _post = this.gestor.postes.clonePost(
							this.DTPerimeterActual.typePost,
							"Poste" + this.DTNamePerTramo + this.DTCountPost++,
							0,
							_alturaPoste,
							this.DTPerimeterActual.direction
						);
						if (_post) {
							// Pintar el poste.
							if (this.DTHasColor) this.paintPost(_post);
							this.DTRootTramo.add(_post);
						}
					}
				}
				this.lastHeight = undefined;
			}
			// ###################################################################################### MUROS y ESCALONES
			else {
				// Si hay muro crearlo y situarlo.
				//console.log("magnitud4: " + _sectionActual.magnitud);

				if (_sectionActual.height > 0) {
					let largo = _sectionActual.magnitud;
					//The extra space for initial or last walls is calculated inside calcWallOffset function
					//(indiceSeccion == 0) ? _sectionActual.magnitud  + 0.08: _sectionActual.magnitud; // Si es el primero escalar 0.08.
					//if (this.DTTramoActual.sections.length == 1 || indiceSeccion == _lastSection || lastTramo) largo += 0.08;

					let nextWallHeight = this.getNextLength(
						indiceSeccion,
						indexTramo
					);
					let offsetResult = this.calcWallOffset(
						_sectionActual.height,
						nextWallHeight,
						indiceSeccion === 0,
						indexTramo === 0,
						indiceSeccion == _lastSection,
						lastTramo
					);
					largo += offsetResult.length;
					let offset = offsetResult.offset;
					if (nextWallHeight) {
						offset += 0.035;
					}

					//console.log("_sectionActual.height :" + _sectionActual.height + " this.lastHeight: "+ this.lastHeight + " nextWallHeight: "+ nextWallHeight);
					//console.log("largo :" + offsetResult.length + " offset: "+ offset);

					let wall = this.gestor.varios.cloneWall(
						largo,
						_sectionActual.height
					);
					if (wall) {
						wall.name =
							"wall" + this.DTNamePerTramo + this.DTCountWall++;

						wall.position.x = offset + _magnitudActual;
						this.DTRootTramo.add(wall);
					}
				}
				this.lastHeight = _sectionActual.height;
				//console.log("magnitud3: " + _sectionActual.magnitud);

				// ################################################################################################ POSTES
				// Colocar postes base (inicio y final de un tramo).
				let post = this.gestor.postes.clonePost(
					this.DTPerimeterActual.typePost,
					"Poste" + this.DTNamePerTramo + this.DTCountPost++,
					_magnitudActual,
					_alturaPoste,
					this.DTPerimeterActual.direction
				);

				if (post) {
					// Pintar el poste.
					if (this.DTHasColor) this.paintPost(post);

					// Situar por defecto en el extremo de inicio.
					this.DTRootTramo.add(post);

					//#####################################################################################
					// Comprobar si su antecesor en más alto.
					// Si es la primera subsección del primer tramo y el perímetro está cerrado.
					if (indiceSeccion == 0) {
						if (indexTramo == 0) {
							if (this.DTPerimeterActual.closed) {
								// Es el primer tramo, solo tener en cuenta si es el principio del perímtero y esta cerrado.
								let se =
									this.DTPerimeterActual.coors[
										this.DTPerimeterActual.coors.length - 2
									].sections;
								let up = se[se.length - 1].height;
								if (up > _sectionActual.height) {
									post.position.y =
										-5 +
										this.DTPerimeterActual.heightPost +
										up;
									post.position.x += 0.035;
									_sectionActual.marginA = 0.035;
								}
								if (_gradostornapuntasOK) {
									// Altura de los tornapuntas dependiendo de la altura del muro y poste.
									if (esCERCADO) {
										this.setTornapuntas(
											Varios3d.TornaPuntasIzquierdo,
											post.position.x,
											alturaTornaPuntas
										);
									}
								}
							} else {
								// Altura de los tornapuntas dependiendo de la altura del muro y poste.
								if (esCERCADO) {
									this.setTornapuntas(
										Varios3d.TornaPuntasIzquierdo,
										post.position.x,
										alturaTornaPuntas
									);
								}
							}
						} else {
							if (esCERCADO && _gradostornapuntasOK) {
								this.setTornapuntas(
									Varios3d.TornaPuntasIzquierdo,
									0,
									(this.DTPerimeterActual.heightPost / 100) *
										75 +
										_sectionActual.height
								);
							}
						}
						// En caso de tener placa base.
						if (this.DTPerimeterActual.basePlaque)
							this.setPlacaBase(
								post.position.x,
								_sectionActual.height
							);
					} else {
						//#####################################################################################
						// Tener en cuenta si la anterior subsección es una puerta.
						if (
							this.DTTramoActual.sections[indiceSeccion - 1]
								.door !== ""
						) {
							post.position.x += 0.035;
							_sectionActual.marginA = 0.035;
							// Colocar tornapuntas extermo izquierdo.
							if (esCERCADO)
								this.setTornapuntas(
									Varios3d.TornaPuntasIzquierdo,
									post.position.x,
									alturaTornaPuntas
								);
							// En caso de tener placa base.
							if (this.DTPerimeterActual.basePlaque)
								this.setPlacaBase(
									post.position.x + 0.035,
									_sectionActual.height
								);
						} else {
							// Adquirir la altura de la última subsección del tramo anterior.
							let up =
								this.DTTramoActual.sections[indiceSeccion - 1]
									.height;
							if (up > _sectionActual.height) {
								post.position.y =
									-5 + this.DTPerimeterActual.heightPost + up;
								post.position.x += 0.035;
								_sectionActual.marginA = 0.035;
								// Colocar tornapuntas extermo derecho.
								if (esCERCADO)
									this.setTornapuntas(
										Varios3d.TornaPuntasDerecho,
										post.position.x,
										alturaTornaPuntas + post.position.y
									);
								// En caso de tener placa base.
								if (this.DTPerimeterActual.basePlaque)
									this.setPlacaBase(
										post.position.x,
										_sectionActual.height
									);
								// Colocar tornapuntas extermo izquierdo.
								if (esCERCADO)
									this.setTornapuntas(
										Varios3d.TornaPuntasIzquierdo,
										post.position.x,
										alturaTornaPuntas
									);
							} else if (up < _sectionActual.height) {
								// En cambio de elevación (escalón) reiniciar las LUX ANUDADAS.
								this.DTMetersLUXAnudada = 0;
								// Colocar tornapuntas extermo izquierdo.
								// En caso de tener placa base.
								if (this.DTPerimeterActual.basePlaque)
									this.setPlacaBase(post.position.x, up);
								// Colocar tornapuntas extermo izquierdo.
								if (esCERCADO)
									this.setTornapuntas(
										Varios3d.TornaPuntasIzquierdo,
										post.position.x,
										alturaTornaPuntas
									);
							}
						}
					}
				}

				//console.log("magnitud2: " + _sectionActual.magnitud);
				//#####################################################################################
				// Solo coloca el último poste si está abierto.
				if (lastTramo && indiceSeccion == _lastSection) {
					if (!this.DTPerimeterActual.closed) {
						let _post = this.gestor.postes.clonePost(
							this.DTPerimeterActual.typePost,
							"Poste" + this.DTNamePerTramo + this.DTCountPost++,
							_magnitudActual + _sectionActual.magnitud,
							_alturaPoste,
							this.DTPerimeterActual.direction
						);
						if (_post) {
							// Pintar el poste.
							if (this.DTHasColor) this.paintPost(_post);
							this.DTRootTramo.add(_post);
						}
						// En caso de tener placa base.
						if (this.DTPerimeterActual.basePlaque)
							this.setPlacaBase(
								_post.position.x,
								_sectionActual.height
							);
						if (esCERCADO) {
							this.setTornapuntas(
								Varios3d.TornaPuntasDerecho,
								_sectionActual.magnitud + _magnitudActual,
								alturaTornaPuntas
							);
						}
					} else {
						if (esCERCADO && _gradostornapuntasOK) {
							this.setTornapuntas(
								Varios3d.TornaPuntasDerecho,
								_sectionActual.magnitud + _magnitudActual,
								alturaTornaPuntas
							);
						}
					}
				}

				//#####################################################################################
				// Tener en cuenta si la siguiente subsección es una puerta.
				//console.log("magnitud1: " + _sectionActual.magnitud);
				if (indiceSeccion < _lastSection) {
					// No es la última sección.

					if (
						this.DTTramoActual.sections[indiceSeccion + 1].door !==
						""
					) {
						let _post = this.gestor.postes.clonePost(
							this.DTPerimeterActual.typePost,
							"Poste" + this.DTNamePerTramo + this.DTCountPost++,
							_magnitudActual + _sectionActual.magnitud - 0.035,
							_alturaPoste,
							this.DTPerimeterActual.direction
						);
						if (_post) {
							// Pintar el poste.
							if (this.DTHasColor) this.paintPost(_post);

							_sectionActual.marginB = 0.035;
							this.DTRootTramo.add(_post);
							// En caso de tener placa base.
							if (this.DTPerimeterActual.basePlaque)
								this.setPlacaBase(
									_post.position.x - 0.035,
									_sectionActual.height
								);

							if (esCERCADO)
								this.setTornapuntas(
									Varios3d.TornaPuntasDerecho,
									_post.position.x,
									alturaTornaPuntas
								);
						}
					}
					//#####################################################################################
					// Tener en cuenta si la siguiente subsección es más alta, pero, se debe tener en cuenta si la sección anterior es una puerta.
					else if (esCERCADO) {
						let esAnteriorPuerta =
							indiceSeccion > 0 &&
							this.DTTramoActual.sections[indiceSeccion - 1]
								.door !== "";
						if (!esAnteriorPuerta) {
							if (indiceSeccion > 0) {
								this.setTornapuntas(
									Varios3d.TornaPuntasDerecho,
									post.position.x,
									(this.DTPerimeterActual.heightPost / 100) *
										75 +
										this.DTTramoActual.sections[
											indiceSeccion - 1
										].height
								);
							} else {
								this.setTornapuntas(
									Varios3d.TornaPuntasDerecho,
									post.position.x +
										_magnitudActual +
										_sectionActual.magnitud,
									(this.DTPerimeterActual.heightPost / 100) *
										75 +
										this.DTTramoActual.sections[
											indiceSeccion
										].height
								);
							}
						}
					}
				}
				//#####################################################################################
				else {
					if (esCERCADO && _sectionActual.door === "" && !lastTramo) {
						if (
							this.DTPerimeterActual.coors[indexTramo + 1]
								.grados >= 40 &&
							this.DTPerimeterActual.coors[indexTramo + 1]
								.grados <= 140
						) {
							this.setTornapuntas(
								Varios3d.TornaPuntasDerecho,
								_magnitudActual + _sectionActual.magnitud,
								(this.DTPerimeterActual.heightPost / 100) * 75 +
									_sectionActual.height
							);
						} else {
							this.setTornapuntas(
								Varios3d.TornaPuntasDerecho,
								_magnitudActual + _sectionActual.magnitud,
								(this.DTPerimeterActual.heightPost / 100) * 75 +
									_sectionActual.height
							);
						}
					}
				}

				// ############################################################################################### MAYA o BASTIDORES
				let distanciaMinimaPostesDobles = 0.084852813742385702928101323452582; // distancia de los postes cuadrados 60x06
				let distanciaThreshold = 0.001;

				if (this.DTPerimeterActual.familia == "CERCADO") {
					// Colocar malla, tener en cuenta si es LUX ANUDADA
					let contadorTramos = 0;
					if (this.DTPerimeterActual.mesh.startsWith("LUX_A")) {
						this.gestor.bastidores.dividerLUXAnudada(
							this,
							_sectionActual,
							_magnitudActual
						);
					} else {
						this.gestor.bastidores.dividerLUX(
							this,
							_sectionActual,
							_magnitudActual
						);
					}
				} else {
					// 'VERJA'
					//##ESPRIVISA-77, eliminar el bastidor cuando hay poste doble
					//##ESPRIVISA-77, comprobamos si estamos en un caso de poste cuadrado como primer filtro

					if (
						this.DTPerimeterActual.perimetro.producto.tipoPoste &&
						this.DTPerimeterActual.perimetro.producto.tipoPoste.includes(
							"Cuadrado"
						)
					) {
						let isMagnitudTooShort =
							Math.abs(
								_sectionActual.magnitud -
									distanciaMinimaPostesDobles
							) < distanciaThreshold;
						if (!isMagnitudTooShort) {
							//console.log('Representamos la subseccion')
							this.gestor.bastidores.divider(
								this,
								_sectionActual,
								_magnitudActual
							);
						} else {
							//console.log('No Representamos la subseccions');
						}
					} else {
						//console.log('No es cuadrado!!!');
						this.gestor.bastidores.divider(
							this,
							_sectionActual,
							_magnitudActual
						);
					}
				}

				//#####################################################################################
				// Colocar espino de las bayonetas si tiene.
				if (
					this.DTPerimeterActual.bayonet != "" &&
					_sectionActual.door == ""
				) {
					let margenEspino =
						this.DTPerimeterActual.typePost.indexOf("50") > -1
							? 0.04
							: 0;
					let bay = this.gestor.varios.cloneEspino(
						_magnitudActual,
						_alturaPoste - margenEspino,
						_sectionActual.magnitud,
						this.DTPerimeterActual.direction
					);
					if (bay) {
						bay.name =
							"Espino" +
							this.DTNamePerTramo +
							this.DTCountEspino++;
						this.DTRootTramo.add(bay);
						if (this.DTPerimeterActual.bayonet == "BD") {
							let bay2 = bay.children[0].clone();
							if (bay2) {
								bay2.scale.z *= -1;
								bay2.name =
									"Espino" +
									this.DTNamePerTramo +
									this.DTCountEspino++;
								this.DTRootTramo.add(bay2);
							}
						}
					}
				}
			}
			// Cuando hay más de una sección en un tramo las magnitudes se tienen que sumar
			_magnitudActual += _sectionActual.magnitud;
		}
		return _magnitudActual;
	}

	private getNextLength(indexSection: number, indexTramo: number) {
		let tramo = this.DTPerimeterActual.coors[indexTramo];
		let vReturn = undefined;
		if (indexSection + 1 < tramo.sections.length) {
			if (tramo.sections[indexSection + 1].door === "") {
				vReturn = tramo.sections[indexSection + 1].height;
			}
		} else if (
			indexTramo + 1 < this.DTPerimeterActual.coors.length - 1 ||
			this.DTPerimeterActual.closed
		) {
			let nextTramo = undefined;
			if (indexTramo + 1 < this.DTPerimeterActual.coors.length - 1) {
				nextTramo = this.DTPerimeterActual.coors[indexTramo + 1];
			} else {
				nextTramo = this.DTPerimeterActual.coors[0];
			}
			if (nextTramo !== undefined && nextTramo.sections[0].door === "") {
				vReturn = nextTramo.sections[0].height;
			}
		}
		return vReturn;
	}

	private calcWallOffset(
		currentHeight: number,
		nextHeight: number,
		firstSection: boolean,
		firstTramo: boolean,
		lastSection: boolean,
		lastTramo: boolean
	) {
		let diametroPoste = this.gestor.postes.length(
			this.DTPerimeterActual.typePost
		);
		let radioPoste = diametroPoste / 2.0;
		let extraLengthWall = 0.0;
		let offsetWall = 0.0;
		if (this.lastHeight === undefined) {
			offsetWall = Math.min(-radioPoste, 0.035);
			if (currentHeight < nextHeight || nextHeight === undefined) {
				extraLengthWall = 2.0 * radioPoste;
			} else if (currentHeight == nextHeight) {
				extraLengthWall = 2.0 * radioPoste;
			}
		} else if (nextHeight === undefined) {
			if (currentHeight < this.lastHeight) {
				offsetWall = -radioPoste;
				extraLengthWall = 2.0 * radioPoste;
			} else if (currentHeight > this.lastHeight) {
				offsetWall = radioPoste;
			} else if (currentHeight === this.lastHeight) {
				//extraLengthWall = radioPoste;
			}
		} else {
			if (currentHeight < this.lastHeight) {
				offsetWall = -radioPoste;
				if (currentHeight < nextHeight) {
					extraLengthWall = 2.0 * radioPoste;
				} else if (currentHeight == nextHeight) {
					extraLengthWall = 2.0 * radioPoste;
				}
			} else if (currentHeight > this.lastHeight) {
				offsetWall = radioPoste;
				if (currentHeight > nextHeight) {
					extraLengthWall = -2.0 * radioPoste;
				} else if (currentHeight == nextHeight) {
					extraLengthWall = radioPoste;
				}
			} else {
				if (currentHeight > nextHeight) {
					offsetWall = -radioPoste;
					//extraLengthWall = -radioPoste;
				} else if (currentHeight < nextHeight) {
					offsetWall = radioPoste;
					//extraLengthWall = -radioPoste;
				} else if (firstSection || lastSection) {
					extraLengthWall = 2.0 * radioPoste;
				}
			}
		}
		if (lastSection && lastTramo && nextHeight === undefined) {
			extraLengthWall += 0.08;
		}
		if (firstSection && firstTramo) {
			offsetWall = -2.0 * radioPoste - 0.08;
			extraLengthWall += 2.0 * radioPoste + 0.08;
		}
		return { length: extraLengthWall, offset: offsetWall };
	}

	public paintPost(post: any) {
		if (!post) return;

		for (let obj = 0; obj < post.children.length; obj++) {
			let element = post.children[obj];
			if (element.name.startsWith("Poste")) {
				element.material = this.DTCacheMaterials.COL_Poste;
			} else if (element.name.startsWith("BAYONETA")) {
				element.material = this.DTCacheMaterials.COL_Bayoneta;
			}
		}
	}

	// Añade un tornapuntas.
	private setTornapuntas(obj: string, x: number, height: number) {
		let tor = this.gestor.varios.clone(obj + (this.DTHasColor ? "" : "G"));
		tor.name = obj + this.DTNamePerTramo + this.DTCountTornaPuntas++;
		tor.position.x = x;
		tor.position.y = height;
		tor.scale.z = -this.DTPerimeterActual.direction;

		// Color.
		if (this.DTHasColor) {
			tor.children[0].material = this.gestor.ColorNeutro;
			if (tor.children.length > 1)
				tor.children[1].material = this.gestor.ColorNeutro;
		}
		this.DTRootTramo.add(tor);
	}

	// Colocar placa base.
	public setPlacaBase(x: number, height: number) {
		let pla = this.gestor.varios.clone(Varios3d.PlacaBase);
		if (pla) {
			pla.position.x = x;
			pla.position.y = height;
			pla.name =
				"PlaqueBase" + this.DTNamePerTramo + this.DTCountPlaqueBase++;

			// Color.
			if (this.DTHasColor) {
				pla.children[0].material = this.DTCacheMaterials.COL_PlacaBase;
			}

			this.DTRootTramo.add(pla);
		}
	}

	// #######################################################################################

	// Captura el evento de cambio de tamaño de la ventana.
	@HostListener("window:resize", ["$event"])
	onResize(event: any) {
		this.camera.aspect = event.target.innerWidth / event.target.innerHeight;
		this.camera.updateProjectionMatrix();
		this.renderer.setSize(
			event.target.innerWidth,
			event.target.innerHeight
		);
	}

	// Renderiza la escena.
	private render() {
		if (this.renderer?.render && this.scene && this.camera) {
			this.renderRequested = false;
			this.renderer.render(this.scene, this.camera);
		}
	}

	// Controla la animación de la escena.
	private animate() {
		if (!this.renderRequested) {
			this.renderRequested = true;
			if (this.render) {
				requestAnimationFrame(this.render.bind(this));
			}
		}
	}

	public findHeightPost() {
		console.log("**** findHeightPost");

		let intersects = [];
		let raycaster = new THREE.Raycaster();

		const geometry = new THREE.SphereGeometry(0.02, 16, 8);
		const material = new THREE.MeshBasicMaterial({ color: 0xff0000 });
		const sphere = new THREE.Mesh(geometry, material);
		sphere.position.copy(
			this.root.children[0].children[0].children[0].position
		);
		sphere.position.y =
			this.root.children[0].children[0].children[0].position.y + 5;
		sphere.name = "debug_sphere";
		this.root.children[0].children[0].add(sphere);
		//console.log(this.root.children[0].children[0].children[0].position);
		raycaster.set(sphere.position, new THREE.Vector3(0, -1, 0));
		console.log(this.scene);
		intersects = raycaster.intersectObjects([this.scene.children[0]]);
		console.log(intersects);
	}
}
